import HeroVideo from './HeroVideo';

export default HeroVideo;
